import "./Home.scss";

import React from "react";

import { Helmet } from 'react-helmet';
import StorePage from "../Store";
import TopBar from "../../components/TopBar";
import { Box, Grid } from "@mui/material";
import BassDistantFrontpageTile from "../../components/Products/BassDistant/FrontpageTile";
import RevFFrontpageTile from "../../components/Products/RevFAmplifierSuite/FrontpageTile";
import DaveFrontpageTile from "../../components/Products/TSDD/FrontpageTile";
import LaunchCountdown from "./LaunchCountdown";

const Home: React.FC = () => {

  return (
    <>
      <div
        style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
      >
        <Helmet>
          <title>WaveMind Audio | Specialist in Guitar Software and Plugins</title>
          <link rel="canonical" href="https://wavemind.net/" />
        </Helmet>
        <TopBar menuValue="0" />

        <LaunchCountdown>
          <Grid container sx={{ display: "flex" }}>
            <Grid item xs={12} md={6}>
              <Box sx={{ height: { xs: "100%", md: "calc(100vh - 64px)" } }}>
                <BassDistantFrontpageTile />
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box sx={{ height: { xs: "100%", md: "calc(50vh - 32px)" }, overflow: "hidden" }}>
                <DaveFrontpageTile />
              </Box>
              <Box sx={{ height: { xs: "100%", md: "calc(50vh - 32px)" }, overflow: "hidden" }}>
                <RevFFrontpageTile />
              </Box>
            </Grid>
          </Grid>
        </LaunchCountdown>

      </div>
      <StorePage useHelmet={false} embedded={true} />
    </>);
};

export default Home;
